import { useEffect, useState, useCallback } from "react";
import { gapi } from "../api";
import { useGAuth } from "../GAuth";
import { Panel } from "../components/ui";

export function Obiettivi() {
  const { user } = useGAuth();
  const [mese, setMese] = useState(new Date().toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  const load = useCallback(() => gapi.get("/goals", { params: { mese } }).then((r) => setD(r.data)).catch(() => setD(null)), [mese]);
  useEffect(() => { load(); }, [load]);
  const setGoal = async (row, k, v) => { await gapi.put("/goals", { mese, userId: row.userId, obiettivi: { ...row.obiettivi, [k]: Number(v) || 0 } }); load(); };
  if (!d) return null;
  const K = ["contatti", "appuntamenti", "valutazioni", "incarichi"];
  return (
    <Panel title="Obiettivi mensili" testid="goals-panel" actions={<input type="month" value={mese} onChange={(e) => setMese(e.target.value)} className="h-9 rounded-lg border border-border-subtle px-2 text-sm" />}>
      <div className="overflow-x-auto"><table className="w-full text-sm min-w-[560px]"><thead><tr className="text-left text-xs text-anthracite/45"><th className="py-1">Chi</th>{K.map((k) => <th key={k} className="capitalize">{k}</th>)}</tr></thead>
        <tbody>{d.righe.map((r) => (
          <tr key={r.userId} className="border-t border-border-subtle"><td className="py-2 font-medium">{r.nome}</td>
            {K.map((k) => <td key={k}><b>{r.risultati[k]}</b> / {user.ruolo === "titolare" ? <input defaultValue={r.obiettivi[k] || ""} onBlur={(e) => setGoal(r, k, e.target.value)} className="w-14 h-8 rounded border border-border-subtle px-1" data-testid={`goal-${r.userId}-${k}`} /> : (r.obiettivi[k] ?? "—")}</td>)}
          </tr>))}</tbody></table></div>
      <p className="text-[11px] text-anthracite/45 mt-2">Criterio: {d.criterio}.</p>
    </Panel>
  );
}
